// src/utils/permissions.ts
import { User } from '../types';

export const hasPermission = (user: User | null, resource: string, action: string): boolean => {
    if (!user || !user.role || !user.role.permissions) return false;
    return user.role.permissions.some(permission =>
        permission.resource === resource && permission.actions.includes(action)
    );
};
